import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteUploadedDocument,
  getAppDocuments,
  getAppDocusignDocs,
  getAppFormLibrary,
  getAppTasks,
  getCandidateApps,
  getUploadDocDeleteStatus,
  loadAppDocuments,
  loadAppDocusignDocs,
  loadAppFormLibrary,
  loadAppRuningTasks,
  loadCandidateApps,
  uploadedDocumentDeleted,
} from "../../store/candidate";
import {
  getCurrentClientDeatils,
  getCurrentUser,
  getLoggedUserDetails,
  loadClientDetails,
  loadUserDetails,
  sign,
} from "../../store/auth";
import { useNavigate } from "react-router-dom";
import { getFieldData } from "../../../Services/appService";
import UploadDocPopup from "../../../Components/UploadDocPopup";
import { getAlert, getConfirmAlert } from "../../../Services/appAlerts";
import { setCurrentPageTitle, setCurrentRoute } from "../../store/layoutUI";
import ViewForm from "../../../Components/ApplicantProcessing/ViewForm";
import {
  getReqDocuments,
  getSignedDocumentData,
  loadReqDocuments,
  loadSignedDocument,
  signedDocumentReceived,
} from "../../store/documents";
import useDocDownload from "../../hooks/useDocDownload";
import {
  getComponentUserStatus,
  UpdateComponentsUserStatus,
} from "../../store/tools";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { getDocDeletedStatus, partnerCandidateDocDelete } from "../../store/partner";

export default function ContractDocs() {
  const usrType = localStorage.getItem("userType");

  const [appTasklist, setAppTasklist] = useState([]);
  const [entityType, setEntityType] = useState("");
  const [signDocs, setSignDocs] = useState([]);
  const [sentDocs, setSentDocs] = useState([]);
  const [receivedDocs, setReceivedDocs] = useState([]);
  const [appFormLibrary, setAppFormLibrary] = useState([]);
  const [reqDocuments, setReqDocuments] = useState([]);
  const [docLoading, setDocLoading] = useState(false);
  const [docLoadingId, setDocLoadingId] = useState(0);
  const [signLoading, setSignLoading] = useState(false);
  const [uploadDocShowHide, setUploadDocShowHide] = useState(false);
  const [selectedSignedDoc, setSelectedSignedDoc] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [docType, setDocType] = useState("");
  const [wfTask, setWfTask] = useState(null);
  const [wfId, setWfId] = useState(0);
  const [formShowHide, setFormShowHide] = useState(false);
  const [formObj, setFormObj] = useState(null);
  const [clientDetails, setClientDetails] = useState(null);

  const candidateAppsSelector = useSelector(getCandidateApps);
  const appTasksSelector = useSelector(getAppTasks);
  const appDocumentsSelector = useSelector(getAppDocuments);
  const userDetailsSelector = useSelector(getLoggedUserDetails);
  const appFormLibrarySelector = useSelector(getAppFormLibrary);
  const reqDocumentsSelector = useSelector(getReqDocuments);
  const appDocusignDocSelector = useSelector(getAppDocusignDocs);
  const signedDocumentDataSelector = useSelector(getSignedDocumentData);
  const componentUserStatusSelector = useSelector(getComponentUserStatus);
  const currentClientDeatilsSelector = useSelector(getCurrentClientDeatils);
  const uploadDocDeleteStatusSelector = useSelector(getUploadDocDeleteStatus);

  const [handleDownloadFile] = useDocDownload();

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();
  const navigate = useNavigate();

  const route = [
    { name: "Task Management", url: "" },
    { name: "Onboarding Steps", url: "" },
  ];
  const route1 = [
    { name: "Contract Management", url: "" },
    { name: "Enrollment Steps", url: "" },
  ];

  useEffect(() => {
    dispatch(setCurrentPageTitle("STEP-2 : Contract Documents"));
    dispatch(setCurrentRoute(usrType === "candidate" ? route : route1));
    dispatch(loadClientDetails());
  }, []);

  useEffect(() => {
    if (!userDetailsSelector && currentUser?.id > 0)
      dispatch(loadUserDetails(currentUser.id));
    if (candidateAppsSelector?.length === 0 && currentUser?.id > 0)
      dispatch(loadCandidateApps(currentUser.id));
    if (appDocusignDocSelector?.length === 0 && currentUser?.id > 0)
      dispatch(loadAppDocusignDocs(currentUser.id));
  }, []);

  useEffect(() => {
    if (appDocusignDocSelector?.length > 0) {
      const docusignDocs = appDocusignDocSelector.filter(
        (x) => x.sendStatus === true
      );
      setSignDocs(docusignDocs);
    } else {
      setSignDocs(appDocusignDocSelector);
    }
  }, [appDocusignDocSelector]);

  useEffect(() => {
    setUserDetails(userDetailsSelector);
  }, [userDetailsSelector]);

  useEffect(() => {
    if (candidateAppsSelector.length > 0 && currentUser?.id > 0) {
      const mainWorkflow = candidateAppsSelector.filter(
        (x) => x.workflowType === 1
      );
      if (mainWorkflow.length > 0) {
        const wf = mainWorkflow[0];
        setWfId(wf.oldWorkflowId);
        if (currentUser?.id > 0) {
          dispatch(loadAppRuningTasks(wf.oldWorkflowId, currentUser.id));
          dispatch(loadAppFormLibrary(wf.oldWorkflowId, currentUser.id));
          dispatch(loadAppDocuments(wf.oldWorkflowId, currentUser.id));
        }
      }
    }
  }, [candidateAppsSelector]);

  useEffect(() => {
    if (appTasksSelector.length > 0) {
      const filterTasks = appTasksSelector.filter(
        (x) => x.taskType === 1 && x.wiid > 0
      );
      setAppTasklist(filterTasks);

      if (filterTasks.length > 0) {
        dispatch(loadReqDocuments(filterTasks[0].ciid));
      }

      if (appTasksSelector.length > 0) {
        const entType = getFieldData(
          appTasksSelector[0].stateData,
          "candidateonboardingform",
          "CandidateEntity"
        );
        setEntityType(entType);
      }
    }
  }, [appTasksSelector]);

  useEffect(() => {
    if (appDocumentsSelector.length > 0) {
      const appDocs = appDocumentsSelector;

      let receiveDoc = appDocs.filter(
        (x) =>
          x.type === "received" &&
          x.uploadType !== "Invoice" &&
          x.uploadType !== "reporting" &&
          x.uploadType !== "client" &&
          x.uploadType !== "project" &&
          x.docType !== "internal" &&
          x.docType !== "Messaging" &&
          x.docModifiedName !== "esign" &&
          //!x.docType?.includes("_c2c") &&
          x.sendStatus === true &&
          x.deleteFlag !== true
      );
      let sentDocs = appDocs.filter(
        (x) =>
          x.type === "send" &&
          x.uploadType !== "Invoice" &&
          x.docType !== "internal" &&
          x.docType !== "Messaging" &&
          x.uploadType !== "Messaging" &&
          x.uploadType !== "reporting" &&
          x.uploadType !== "monthly_time_sheet" &&
          x.uploadType?.substring(0, 3) !== "ach" &&
          x.uploadType?.substring(0, 3) !== "req" &&
          x.uploadType?.substring(0, 9) !== "insurance"
      );
      setReceivedDocs(receiveDoc);
      setSentDocs(sentDocs);

      let docItems = "";
      receiveDoc.forEach((x, key) => {
        if (key > 0) docItems += ",";
        docItems += x.id;
      });

      sentDocs.forEach((x, key) => {
        if (key > 0 || docItems !== "") docItems += ",";
        docItems += x.id;
      });

      appDocs
        .filter((x) => x.docModifiedName === "esign")
        .forEach((x, key) => {
          if (key > 0 || docItems !== "") docItems += ",";
          docItems += x.id;
        });

      let appCiid = 0;
      if (receiveDoc.length > 0) appCiid = receiveDoc[0].ciid;

      if (sentDocs.length > 0) appCiid = sentDocs[0].ciid;

      handleUpdateComponent(docItems, appCiid);
    }
  }, [appDocumentsSelector]);

  useEffect(() => {
    if (appFormLibrarySelector.length > 0) {
      const frmLibrary = appFormLibrarySelector.filter(
        (x) =>
          x.formType !== "ACH Information" &&
          x.formType !== "Insurance Information"
      );
      setAppFormLibrary(frmLibrary);
    }
  }, [appFormLibrarySelector]);

  useEffect(() => {
    if (reqDocumentsSelector.length > 0) {
      const reqDocs = reqDocumentsSelector.filter(
        (x) =>
          x.sendStatus === true && x.performerId === parseInt(currentUser?.id)
      );
      setReqDocuments(reqDocs);

      if (reqDocs.length > 0) {
        let docItems = "";
        receivedDocs.forEach((x, key) => {
          if (key > 0) docItems += ",";
          docItems += x.id;
        });

        sentDocs.forEach((x, key) => {
          if (key > 0 || docItems !== "") docItems += ",";
          docItems += x.id;
        });

        reqDocs.forEach((x, key) => {
          if (key > 0 || docItems !== "") docItems += ",";
          docItems += x.id;
        });

        let appCiid = 0;
        if (receivedDocs.length > 0) appCiid = receivedDocs[0].ciid;

        if (sentDocs.length > 0) appCiid = sentDocs[0].ciid;

        handleUpdateComponent(docItems, appCiid);
      }
    }
  }, [reqDocumentsSelector]);

  const handleViewSignedDoc = (item, type) => {
    setSelectedSignedDoc(item);
    setSignLoading(true);
    dispatch(loadSignedDocument(item.id, type));
  };

  useEffect(() => {
    if (signedDocumentDataSelector && selectedSignedDoc) {
      const url = window.URL.createObjectURL(signedDocumentDataSelector);
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";

      if (selectedSignedDoc?.docName)
        link.setAttribute("download", selectedSignedDoc.docName);
      else if (selectedSignedDoc?.documentName)
        link.setAttribute("download", selectedSignedDoc.documentName);
      else link.setAttribute("download", "ipcs_document");

      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setSelectedSignedDoc(null);
      setSignLoading(false);
      dispatch(signedDocumentReceived(null));
    }
  }, [signedDocumentDataSelector]);

  useEffect(() => {
    setClientDetails(currentClientDeatilsSelector);
  }, [currentClientDeatilsSelector]);

  const handleUploadShowHide = (type) => {
    if (type === "save") {
      setUploadDocShowHide(false);
      dispatch(loadAppDocuments(wfId, currentUser.id));
    } else {
      const reviewApp = appTasklist.filter((x) => x.registrationType === "WP");
      if (reviewApp.length > 0) {
        const lastReviewer = reviewApp[0];
        setWfTask([lastReviewer]);
      } else {
        getAlert("", "No reviewer found", "error");
      }
      setUploadDocShowHide(!uploadDocShowHide);
      setDocType(type);
    }
  };

  const handleFormShowHide = (frm) => {
    if (frm === "save") {
      setFormShowHide(false);
      setFormObj("");
    } else {
      setFormShowHide(!formShowHide);
      setFormObj(frm);
    }
  };

  const handleDeleteFile = async (doc, type, item) => {
    if (item?.status === 1) return getAlert("", "You cannot delete approved document", "error");
    if (item?.docStatus === 1) return getAlert("", "You cannot delete approved document", "error");
    const confirm = await getConfirmAlert("", "Are you sure you want to delete this document?", "warning");
    if (confirm.isConfirmed) {
      dispatch(deleteUploadedDocument(doc.id, type));
    }
  };

  useEffect(() => {
    if (uploadDocDeleteStatusSelector) {
      getAlert("", "Deleted Successfully", "success");
      dispatch(uploadedDocumentDeleted(false));
      if (wfId > 0)
        dispatch(loadAppDocuments(wfId, currentUser.id));
    }
  }, [uploadDocDeleteStatusSelector])

  const getReqUploadedDocs = (item, type) => {
    const achDocs = appDocumentsSelector.filter(
      (x) => x.docType === `req_${item.id}`
    );

    if (achDocs.length === 0) {
      return (
        <>
          <td>
            {item.docType?.includes("_c2c_") && "Contract"}
            {item.docType !== "sharing" &&
              !item.docType?.includes("_c2c_") &&
              type !== "received"
              ? "Pending"
              : type === "received" && "Received"}
          </td>
          <td>
            {item.docType !== "sharing" &&
              !item.docType?.includes("_c2c_") &&
              type !== "received" && (
                <button
                  className="btn btn-outline-default btn-sm btn-min-width"
                  onClick={() => handleUploadShowHide(`req_${item.id}`)}
                >
                  <i className="fa fa-upload"></i> Upload
                </button>
              )}
          </td>
        </>
      );
    }

    if (achDocs.length > 0) {
      const doc = achDocs[achDocs.length - 1];
      return (
        <>
          <td>Uploaded</td>
          <td>
            <button
              className="btn btn-link btn-sm p-0"
              title="Download Document"
              onClick={() => handleDownloadFile(doc)}
            >
              {doc.documentName}
            </button>
            {getPopover(doc.notes)}
            <button
              className="btn btn-sm btn-link text-danger p-0"
              title="Delete File"
              onClick={() => handleDeleteFile(doc, "doc", item)}
            >
              <i className="fa fa-trash"></i>
            </button>
          </td>
        </>
      );
    }
  };

  const getReqRefDocs = (item) => {
    if (item.refDocId > 0) {
      const findDocs = appDocumentsSelector.filter(
        (x) => x.uploadId === item.refDocId
      );
      if (findDocs.length > 0) {
        return (
          <>
            {findDocs.map((doc) => (
              <td>
                <button
                  className="btn btn-link btn-sm p-0"
                  title="Download Document"
                  onClick={() => handleDownloadFile(doc)}
                >
                  {doc.documentName}
                </button>
                <br />
                {item.documnetName}
              </td>
            ))}
          </>
        );
      }
    }

    return <td>{item.documnetName}</td>;
  };

  const getUnsignedDoc = (item) => {
    const signDoc = appDocumentsSelector.filter(
      (x) => x.docData === item.docData
    );
    if (signDoc.length === 0) {
      return (
        <>
          <td>{item.documentName}</td>
        </>
      );
    }

    if (signDoc.length > 0) {
      const doc = signDoc[0];
      return (
        <>
          <td>
            <button
              className="btn btn-link btn-sm p-0"
              title="Download Document"
              onClick={() => handleDownloadFile(doc)}
            >
              {doc.documentName}
            </button>
          </td>
        </>
      );
    }
  };

  const handleUpdateComponent = (compItems, ciid) => {
    const comp = componentUserStatusSelector.filter((x) => x.compId === 3);
    let updCompItems = "";
    if (comp.length > 0) {
      updCompItems = comp[0].compItems;
    }
    const compObj = {
      compName: "Contract Document",
      performerId: currentUser.id,
      compItems: compItems,
      ciid: ciid,
      wiid: 0,
      iiid: 0,
      compId: 3,
    };
    if (compItems !== "" && compItems !== updCompItems) {
      dispatch(UpdateComponentsUserStatus(compObj));
    }
  };

  const getPopover = (notes) => {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h4">Notes</Popover.Title>
        <Popover.Content>{notes}</Popover.Content>
      </Popover>
    );
    return (
      <OverlayTrigger trigger="click" placement="top" overlay={popover}>
        <i
          className="fa fa-info-circle btn btn-sm"
          style={{ cursor: "pointer" }}
        ></i>
      </OverlayTrigger>
    );
  };

  const getPopover1 = (notes) => {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h4">Notes</Popover.Title>
        <Popover.Content>{notes}</Popover.Content>
      </Popover>
    );
    return (
      <OverlayTrigger trigger="click" placement="top" overlay={popover}>
        <button className="btn btn-sm btn-link"> View</button>
      </OverlayTrigger>
    );
  };

  const handleDocumentLoad = () => {
    dispatch(loadAppDocuments(wfId, currentUser.id));
    dispatch(loadAppDocusignDocs(currentUser.id));
    dispatch(loadAppFormLibrary(wfId, currentUser.id));
    dispatch(loadReqDocuments(wfId));
  };

  // Step 1: Merge and tag arrays
  const mergedDocs = [
    ...reqDocuments.map((item) => ({
      ...item,
      type: "req",
      date: item.addedDateTime,
    })),
    ...receivedDocs.map((item) => ({
      ...item,
      type: "received",
      date: item.createdDateTime,
    })),
    ...signDocs.map((item) => ({
      ...item,
      type: "sign",
      date: item.createdDateTime,
    })),
    ...sentDocs.map((item) => ({
      ...item,
      type: "sent",
      date: item.createdDateTime,
    })),
  ];

  // Step 2: Sort by date (latest first, or reverse if needed)
  const sortedDocs = mergedDocs.sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  return (
    <React.Fragment>
      <div className="col-md-12 mt-2 form-group">
        <div className="card border shadow-none">
          <div className="card-header p-3">
            <div className="row">
              <div className="col-md-8">
                {/* <i className="fa fa-square wf-phase2-box mr-2" ></i> */}
                <span className="h3">Contract and other documents</span>
                <p className="text-black">
                  Download, complete, sign and upload documents as PDF. In this
                  section you will also see the final executed contract
                  documents.
                </p>
              </div>
              <div className="col-md-4 text-right">
                <button
                  className="btn btn-sm btn-outline-default mt-2 btn-min-width"
                  title="Use this feature to upload any documents as may be required."
                  onClick={() => handleUploadShowHide("")}
                >
                  <i className="fa fa-upload"></i> Upload
                </button>
              </div>
            </div>
          </div>
          <div className="card-body p-3">
            <div className="table-responsive">
              <p className="text-black mb-2">
                <button
                  className="btn btn-sm btn-link pl-0 pr-0 mr-0"
                  onClick={handleDocumentLoad}
                >
                  Refresh
                </button>
                | (Open password protected document : First 3 letters of your
                first name and starting 3 charactors of the your ID in lower
                case) Example - (abc123).
              </p>
              <table className="table align-items-center table-flush table-hover table-striped border">
                <thead className="thead-light">
                  <tr>
                    <th>S.No.</th>
                    <th>Date & Time</th>
                    <th>Requirement</th>
                    <th>Notes</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {sortedDocs.map((item, key) => (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td>
                        <Moment format="MMM Do YYYY, h:mm a">
                          {item.date}
                        </Moment>
                      </td>

                      {/* Handle by type */}
                      {item.type === "req" && (
                        <>
                          {getReqRefDocs(item)}
                          <td>{getPopover1(item.notes)}</td>
                          {getReqUploadedDocs(item, "req")}
                        </>
                      )}

                      {item.type === "received" && (
                        <>
                          <td>
                            <button
                              className="btn btn-sm btn-link pl-0"
                              title="Download Document"
                              onClick={() => handleDownloadFile(item)}
                            >
                              {item.documentName}
                            </button>
                          </td>
                          <td>{getPopover1(item.notes)}</td>
                          {getReqUploadedDocs(item, "received")}
                        </>
                      )}

                      {item.type === "sign" && (
                        <>
                          <td>
                            <button
                              className="btn btn-link btn-sm p-0"
                              title="Download Document"
                              onClick={() => handleViewSignedDoc(item, "0")}
                            >
                              {item.documentName}
                            </button>
                          </td>
                          <td>{getPopover1(item.remarks)}</td>
                          <td>
                            {item.signedStatus === "1" ? "Signed" : "Pending"}
                          </td>
                          <td>
                            {item.signedStatus === "1" ? (
                              <button
                                className="btn btn-link btn-sm p-0"
                                title="Download Document"
                                onClick={() => handleViewSignedDoc(item, "1")}
                              >
                                {item.documentName}
                              </button>
                            ) : (
                              <>
                                {item.signedStatus === "0" && (
                                  <a
                                    className="btn btn-outline-dark btn-sm"
                                    target="blank"
                                    href={`${process.env.REACT_APP_ESIGN_BASEURL}/${item?.id}_${item.ciid}_${currentUser?.id}_${clientDetails?.clientId}_${item.documentName}_contractPartner`}
                                  >
                                    Complete and Sign
                                  </a>
                                )}
                                {item.signedStatus === null && (
                                  <a
                                    className="btn btn-outline-dark btn-sm"
                                    target="blank"
                                    href={`${process.env.REACT_APP_ESIGN_BASEURL}/${item?.docId}_${item.ciid}_${currentUser?.id}_${clientDetails?.clientId}_${item.documentName}_esignPartner`}
                                  >
                                    Complete and Sign
                                  </a>
                                )}
                              </>
                            )}
                          </td>
                        </>
                      )}

                      {item.type === "sent" && (
                        <>
                          <td>
                            <button
                              className="btn btn-sm btn-link pl-0"
                              title="Download Document"
                              disabled={docLoading && item.id === docLoadingId}
                              onClick={() => handleDownloadFile(item)}
                            >
                              {docLoading && item.id === docLoadingId && (
                                <i className="fa fa-circle-o-notch fa-spin mr-1"></i>
                              )}
                              {item.documentName}
                            </button>
                          </td>
                          <td>{getPopover1(item.notes)}</td>
                          <td>Sent</td>
                          <td>
                            <button
                              className="btn btn-sm btn-link text-danger"
                              title="Delete File"
                              onClick={() => handleDeleteFile(item, "doc", item)}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {uploadDocShowHide && (
        <UploadDocPopup
          uploadDocShowHide={uploadDocShowHide}
          handleUploadDocModalShowHide={handleUploadShowHide}
          runningApplication={wfTask}
          selectedDocType={docType}
          contactDoc={
            docType === ""
              ? "Your document has been successfully attached to workbench portal"
              : "Your required document has been successfully attached to workbench portal"
          }
        ></UploadDocPopup>
      )}
      {formShowHide && (
        <ViewForm
          formShowHide={formShowHide}
          handleFormShowHide={handleFormShowHide}
          workflowTask={wfTask}
          selectedForm={formObj}
        ></ViewForm>
      )}
    </React.Fragment>
  );
}
